import * as React from "react";
import { Input } from "antd";

class RewriteInput extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <div className="rewrite-input">
        <Input placeholder="6666" addonBefore={<span>名称</span>} />
        {/* <span className="small-label">名称</span> */}
      </div>
    );
  }
}

export default RewriteInput;
